import axios from "axios";
import { getConfig } from "../config/config";

export async function deleteResearch(token: string, pesquisaID: string) {
  try {
    const url = `${getConfig().API_URL}/deletarPesquisa/${pesquisaID}`;
    const response = await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { pesquisaID },
    });
    return { success: true, message: "", result: response };
  } catch (error: any) {
    return { success: false, message: error?.message || "Erro ao deletar.", result: "" };
  }
}
